import { addClientTour } from './definitions/addClient.js';
import { dashboardTour } from './definitions/dashboard.js';
import { sidebarTour } from './definitions/sidebar.js';
import { riskRatingsTour } from './definitions/riskRatings.js';
import { editClientTour } from './definitions/editClient.js';
import { clientDetailTour } from './definitions/clientDetail.js';
import { raiseEscalationTour } from './definitions/raiseEscalation.js';
import { handleEscalationTour } from './definitions/handleEscalation.js';
import { notificationsTour } from './definitions/notifications.js';
import { serviceAuditTour } from './definitions/serviceAudit.js';
import { cddStatusTour } from './definitions/cddStatus.js';
import { searchFilterClientsTour } from './definitions/searchFilterClients.js';
import { exportClientTour } from './definitions/exportClient.js';
import { associatedPersonsTour } from './definitions/associatedPersons.js';
import { offboardingTour } from './definitions/offboarding.js';
import { ongoingMonitoringTour } from './definitions/ongoingMonitoring.js';

// Each tour: { id, title, description, autoLaunchOn?, steps }
//   id          — stable string used in localStorage and start() calls
//   title       — shown on the help page
//   description — shown on the help page
//   autoLaunchOn — optional. Object: { page: '<aml-nav-key>' } — first-time auto-launch trigger,
//                  also used by the help page to navigate to the right page before launching.
//   steps       — array (or function returning array) of Shepherd step objects
export const tours = [
    // Orientation — basic layout first.
    dashboardTour,
    sidebarTour,

    // Primary client work — the bread-and-butter actions a new user will
    // reach for first. Add Client deliberately leads.
    addClientTour,
    clientDetailTour,
    editClientTour,
    searchFilterClientsTour,
    exportClientTour,

    // Client lifecycle — secondary actions on an existing client.
    associatedPersonsTour,
    ongoingMonitoringTour,
    offboardingTour,

    // Concept explainers — useful but not where a new user starts.
    riskRatingsTour,
    cddStatusTour,
    notificationsTour,

    // Escalations
    raiseEscalationTour,
    handleEscalationTour,

    // Reporting & audit
    serviceAuditTour,
];
